import { from } from "rxjs";
import { delay, filter, switchMap } from "rxjs/operators";
import { selectExperienceProductionBuffAmount } from "../../../selectors/selectBuffsInfo";
import { selectBuffFactorAddition, selectBuffProductPellet, } from "../../../selectors/selectProduction";
import { utilBuildings } from "../../../utils/utilBuildings";
import { getResourceIconInfo } from "../../generic/icon/getResourceIconInfo";
import { IdIcon } from "../../generic/icon/IdIcon";
import { TypeActionProductionInfo, } from "../../info/production/actionProductionInfo";
import { actionAddPelletsAnimations } from "../actionPelletAnimations";
export var epicCollectProductAnimation = function (action$, state$) {
    return action$.pipe(filter(function (action) {
        return (action.type === TypeActionProductionInfo.PreCollect ||
            action.type === TypeActionProductionInfo.PostCollect);
    }), 
    // add a small delay to allow building/callout to be re-rendered before starting pellet animation
    delay(25), switchMap(function (action) {
        var building = action.building, products = action.products;
        var proto = building.proto;
        var state = state$.value;
        var origin = utilBuildings.getCenterPositionMinSquareGlobal(building);
        var buffFactorAddition = selectBuffFactorAddition(state, building);
        var rewardPellets = [];
        products.product.forEach(function (resource) {
            rewardPellets.push(getResourceIconInfo(resource));
            rewardPellets.push(selectBuffProductPellet(state, resource, buffFactorAddition));
        });
        rewardPellets.push({
            amount: products.xp,
            icon: IdIcon.XpIcn,
        });
        rewardPellets.push({
            amount: selectExperienceProductionBuffAmount(state, products.xp),
            icon: IdIcon.XpIcn,
        });
        return from([actionAddPelletsAnimations(proto.id, rewardPellets, origin)]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/animation/epics/epicCollectProductAnimation.ts
// module id = 1766
// module chunks = 3